/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Cognito_Group_LabelInputs */

const en_cognito_group_label = /** @type {(inputs: Cognito_Group_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.group === "Admin") return /** @type {LocalizedString} */ (`Admin`);
	if (i?.group === "Manager") return /** @type {LocalizedString} */ (`Manager`);
	if (i?.group === "Negotiator") return /** @type {LocalizedString} */ (`Negotiator`);
	if (i?.group === "Legal") return /** @type {LocalizedString} */ (`Legal`);
	if (i?.group === "Operator") return /** @type {LocalizedString} */ (`Operator`);
	if (i?.group === "Customer") return /** @type {LocalizedString} */ (`Customer`);
	if (i?.group === "Partner") return /** @type {LocalizedString} */ (`Partner`);
	if (i?.group === "Expert") return /** @type {LocalizedString} */ (`Expert`);
	if (i?.group === "Automation") return /** @type {LocalizedString} */ (`Automation`);
	return /** @type {LocalizedString} */ (`${i?.group}`)
	
};

const pt_br2_cognito_group_label = /** @type {(inputs: Cognito_Group_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.group === "Admin") return /** @type {LocalizedString} */ (`Administrador`);
	if (i?.group === "Manager") return /** @type {LocalizedString} */ (`Gestor`);
	if (i?.group === "Negotiator") return /** @type {LocalizedString} */ (`Negociador`);
	if (i?.group === "Legal") return /** @type {LocalizedString} */ (`Jurídico`);
	if (i?.group === "Operator") return /** @type {LocalizedString} */ (`Operador`);
	if (i?.group === "Customer") return /** @type {LocalizedString} */ (`Cliente`);
	if (i?.group === "Partner") return /** @type {LocalizedString} */ (`Parceiro`);
	if (i?.group === "Expert") return /** @type {LocalizedString} */ (`Perito`);
	if (i?.group === "Automation") return /** @type {LocalizedString} */ (`Automação`);
	return /** @type {LocalizedString} */ (`${i?.group}`)
	
};

/**
* | group | output |
* | --- | --- |
* | "Admin" | "Admin" |
* | "Manager" | "Manager" |
* | "Negotiator" | "Negotiator" |
* | "Legal" | "Legal" |
* | "Operator" | "Operator" |
* | "Customer" | "Customer" |
* | "Partner" | "Partner" |
* | "Expert" | "Expert" |
* | "Automation" | "Automation" |
* | * | "{group}" |
*
* @param {Cognito_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_group_label = /** @type {((inputs: Cognito_Group_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Group_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_group_label(inputs)
	return pt_br2_cognito_group_label(inputs)
});